import { render, staticRenderFns } from "./DiscountTag.vue?vue&type=template&id=25d12aa9&scoped=true&lang=pug&"
import script from "./DiscountTag.vue?vue&type=script&lang=js&"
export * from "./DiscountTag.vue?vue&type=script&lang=js&"
import style0 from "./DiscountTag.vue?vue&type=style&index=0&id=25d12aa9&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d12aa9",
  null
  
)

export default component.exports